import React from "react";
import ManualImportData from "../components/manual-import-file";

function ImportData() {
  return (
    <>
      <ManualImportData />
    </>
  );
}

export default ImportData;
